<template>
  <div class="blog">
    <div class="container background-container">
      <div class="row">
        <div class="col-md-12 p-0 pt-4">
          <img
            class="blog__header-image"
            src="@/assets/images/blog/lockdowncooking/header.jpg"
            alt="header-image"
          />
        </div>
      </div>
    </div>

    <div class="container p-md-0">
      <div class="row">
        <div class="col-md-12 p-md-0">
          <h1 class="blog__title">Lockdown cooking changed my life.</h1>
        </div>
      </div>

      <div class="row position-relative">
        <div
          v-if="userAgent && !isInstagramBrowser"
          class="blog__social d-md-flex d-none"
        >
          <span class="blog__social-title">Share</span>
          <div
            v-for="(link, key) in socialLinks"
            :key="key"
            class="mt-2"
            @click="handleShareClick"
          >
            <img :src="getImageItem(key)" :alt="key" />
          </div>
        </div>
        <div class="col-md-8 offset-md-2">
          <p>
            What do a pair of teachers who live in Missouri, a former
            hospitality manager based in Mississippi and a fitness fan from the
            Northeast of England all have in common?
          </p>
          <p>
            They have all taken their lockdown hobby and turned it into a new
            career.
          </p>
          <p>
            At Found we have creators across the USA and UK and while they may
            be geographically separated, have different backgrounds and
            different lives, they do have something that ties them together.
          </p>
          <p>
            And that’s their passion for cooking has not only seen them find
            themselves a worldwide audience, but they have also been able to
            take that content and turn it into a new way of life.
          </p>
          <p>
            Take Luke Brown for example. Luke and his wife Kelli were both full
            time teachers, juggling their work commitments with looking after
            two young children at their Missouri home.
          </p>
          <p>
            Luke decided two years ago to start sharing some of his quick and
            easy recipes online – and admits he was totally unprepared for what
            followed.
          </p>
          <p>
            His simple, delicious and family friendly recipes have struck a
            massive chord on platforms like Instagram and TikTok – so much so
            that he has a staggering 1.8m followers on the latter.
          </p>

          <div class="blog__double-image my-4">
            <img src="@/assets/images/blog/lockdowncooking/2.jpg" alt="image" />
            <img src="@/assets/images/blog/lockdowncooking/3.jpg" alt="image" />
          </div>

          <p>
            Now that’s great for recognition, but recognition doesn’t feed your
            family. It made sense for Luke – and the other people we’ve
            mentioned above like Caroline Davies -aka @mississippi_kween– and
            Sophie Clothier, an English personal trainer who shares her recipes
            under the name @fitfooddiary_x - to use their hobbies to make money
            – and they’ve all gone on to create successful cookbooks with Found.
          </p>
          <p>
            Luke, who can be found @cookinginthemidwest, has found that what
            started off as a fun diversion has actually turned into a full time
            job – so much so that both he and his wife have given up their
            teaching posts.
          </p>

          <div class="blog__double-image my-4">
            <img src="@/assets/images/blog/lockdowncooking/4.jpg" alt="image" />
            <img src="@/assets/images/blog/lockdowncooking/5.jpg" alt="image" />
          </div>

          <p>
            And the same goes for Sophie and so many other content creators,
            such as Desarae Legros, aka @cooking_comedy_chaos, who has found a
            new career by sharing her online recipes, after an accident meant
            she was unable to return to work.
          </p>
          <p>
            It’s a big step, to change your working world, but these creators–
            and many more – don’t regret it for a minute.
          </p>
          <p>
            Luke was overwhelmed by the thousands of pre-orders for his book and
            Caroline has to date sold a staggering 13,000 cookbooks – and has
            just published her second one.
          </p>
          <p>
            And because of the ever-evolving opportunities at Found, it doesn’t
            just stop at cookbooks.
          </p>
          <p>
            The merchandise range is constantly growing, meaning there’s
            additional income to be found selling everything from aprons to mugs
            which are personalised to the creator’s brand.
          </p>
          <p>
            Nobody doubts that it’s a huge leap to turn a hobby into a full-time
            job, but for anyone that has the commitment, it could well be the
            best move they ever make.
          </p>
          <p>
            You will need to think about constantly creating new recipes and new
            posts – you need your followers to stay engaged so think about
            delivering content from three to five times a week minimum.
          </p>
          <p>
            Research shows there’s even optimum times to post, to help increase
            your levels of engagement, which is vital if you’re really serious
            about turning your hobby into a profession.
          </p>
          <p>
            Try and avoid weekends, while Tuesdays, Wednesdays, and Thursdays
            between 9am and noon are seen as really successful to engage with
            people on Instagram.
          </p>
          <p>
            Tuesdays and Wednesdays are also seen as great days to post on
            TikTok, usually between 2pm and 5pm for maximum impact.
          </p>
          <p>
            Taking what started out as a fun hobby and turning it that into a
            serious job can be very daunting, but it can be done – just look at
            some our Found creators.
          </p>
          <p>
            And the good news is that we’re also here to support you at every
            step of your exciting journey – so what are you waiting for?
          </p>

          <div
            v-if="userAgent && !isInstagramBrowser"
            class="blog__social d-md-none"
          >
            <span class="blog__social-title">Share</span>
            <div class="d-flex">
              <div
                v-for="(link, key) in socialLinks"
                :key="key"
                class="mt-2 mr-md-0 mr-3"
                @click="handleShareClick"
              >
                <img :src="getImageItem(key)" :alt="key" />
              </div>
            </div>
          </div>

          <div v-if="tags && tags.length">
            <h2 class="mt-4">Related topics</h2>
            <div class="blog__tags">
              <Tag
                v-for="tag in tags"
                :key="tag"
                class="mr-3 my-2"
                @click="onTagClick(tag)"
              >
                {{ tag }}
              </Tag>
            </div>
          </div>

          <div class="blog__action-button mt-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              @click="handleBeFoundClick"
            >
              I’m ready to talk
            </Button>
          </div>

          <Carousel
            v-if="creatorProducts && creatorProducts.length"
            id="blog-products"
            class="my-4"
            :items="creatorProducts"
            :mode="CarouselModes.PRODUCT"
            show-default-item-actions
            @click="handleProductBundleClick"
          >
            <template #title>
              <h2>More from {{ creatorHandle }}</h2>
            </template>
          </Carousel>

          <Carousel
            v-if="creatorProducts2 && creatorProducts2.length"
            id="creatorProducts"
            class="my-4"
            :items="creatorProducts2"
            :mode="CarouselModes.PRODUCT"
            show-default-item-actions
            @click="handleProductBundleClick"
          >
            <template #title>
              <h2>More from {{ creatorHandle2 }}</h2>
            </template>
          </Carousel>

          <Carousel
            v-if="creatorProducts3 && creatorProducts3.length"
            id="creatorProducts"
            class="my-4"
            :items="creatorProducts3"
            :mode="CarouselModes.PRODUCT"
            show-default-item-actions
            @click="handleProductBundleClick"
          >
            <template #title>
              <h2>More from {{ creatorHandle3 }}</h2>
            </template>
          </Carousel>

          <Carousel
            v-if="creatorProducts4 && creatorProducts4.length"
            id="creatorProducts"
            class="my-4"
            :items="creatorProducts4"
            :mode="CarouselModes.PRODUCT"
            show-default-item-actions
            @click="handleProductBundleClick"
          >
            <template #title>
              <h2>More from {{ creatorHandle4 }}</h2>
            </template>
          </Carousel>

          <div class="blog__action-button mt-3 mb-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              variant="outline"
              @click="$router.push('/blog')"
            >
              View all blogs
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { throttle } from 'lodash';
import socialLinks from '@/misc/socialLinks';
import { CarouselModes, WebApiCancelError } from '@/misc/constants';
import Tag from '@/components/Elements/Tag.vue';
import Button from '@/components/Elements/Button.vue';
import getDefaultProductFormat from '@/misc/getDefaultProductFormat';
import formatMoney from '@/misc/formatMoney';
import getFormatPrice from '@/misc/getFormatPrice';
import { fetchProductsByCreator } from '@/services/products';
import filterProductsByRegion from '@/misc/filterProductByRegion';

export default {
  name: 'BlogItemPage',
  components: {
    Button,
    Tag,
    Carousel: () =>
      import(/* webpackPrefetch: true */ '@/components/Carousel/Index')
  },

  data() {
    return {
      creatorHandle: 'mississippi_kween',
      creatorHandle2: 'cookinginthemidwest',
      creatorHandle3: 'fitfooddiary_x',
      creatorHandle4: 'cooking_comedy_chaos',
      CarouselModes,
      socialLinks,
      creatorProducts: [],
      creatorProducts2: [],
      creatorProducts3: [],
      creatorProducts4: [],
      tags: ['General']
    };
  },

  head: {
    title: 'Be Found | Blog'
  },

  computed: {
    ...mapState('main', ['userAgent']),
    ...mapGetters({
      isInstagramBrowser: 'main/isInstagramBrowser',
      currency: 'config/currency',
      region: 'config/region'
    })
  },

  mounted() {
    fetchProductsByCreator(this.$axios, this.creatorHandle).then((response) => {
      const creatorProducts = this.$get(response, 'creatorProducts');
      this.creatorProducts = filterProductsByRegion(
        creatorProducts,
        this.region
      );
    });
    fetchProductsByCreator(this.$axios, this.creatorHandle2).then(
      (response) => {
        const creatorProducts = this.$get(response, 'creatorProducts');
        this.creatorProducts2 = filterProductsByRegion(
          creatorProducts,
          this.region
        );
      }
    );
    fetchProductsByCreator(this.$axios, this.creatorHandle3).then(
      (response) => {
        const creatorProducts = this.$get(response, 'creatorProducts');
        this.creatorProducts3 = filterProductsByRegion(
          creatorProducts,
          this.region
        );
      }
    );
    fetchProductsByCreator(this.$axios, this.creatorHandle4).then(
      (response) => {
        const creatorProducts = this.$get(response, 'creatorProducts');
        this.creatorProducts4 = filterProductsByRegion(
          creatorProducts,
          this.region
        );
      }
    );
  },

  methods: {
    getImageItem(key) {
      return require(`@/assets/icons/social/${key}.svg`);
    },

    onTagClick(tag) {
      this.$router.push('/blog?filter=' + tag);
    },

    handleBeFoundClick() {
      this.$router.push({ path: '/be-found' });
    },

    handleShareClick: throttle(function () {
      const url = window.location.href;
      if (navigator?.share) {
        navigator.share({ url }).catch((err) => {
          if (!err.message.includes(WebApiCancelError)) {
            this.$showToastMessage(err.message, 'Error', 'error');
          }
        });
      } else if (navigator?.clipboard) {
        navigator.clipboard
          .writeText(url)
          .then(() =>
            this.$showToastMessage('Link is copied', 'Success', 'success')
          )
          .catch((err) =>
            this.$showToastMessage(
              `Failed to copied link ${err.message}`,
              'Error',
              'error'
            )
          );
      } else {
        this.$showToastMessage(
          `Sharing function is not supported`,
          'Error',
          'error'
        );
      }
    }, 1500),

    getProductFormatPrice(product) {
      const defaultFormat = getDefaultProductFormat(product);
      return formatMoney(
        getFormatPrice(defaultFormat, this.region)?.amount,
        this.currency
      );
    },

    handleProductBundleClick(product) {
      this.$router.push({
        path: `/products/${product.id || product.item.id}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.blog {
  &__header-image {
    object-fit: cover;
    height: 480px;
    width: 100%;
  }

  &__title {
    padding-top: 40px;
    text-align: left;
    line-height: 56px;
  }

  &__landscape-image {
    object-fit: contain;
    height: 550px;
    width: 100%;
    margin-bottom: 40px;
  }

  &__social {
    position: absolute;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    text-align: center;

    &-title {
      font-size: 12px;
    }
  }

  &__double-image {
    display: flex;
    justify-content: space-around;

    img {
      object-fit: cover;
      height: 700px;
      &:first-child {
        margin-right: 20px;
      }
    }
  }

  &__quote {
    font-family: 'Poppins-SemiBold', sans-serif;
    font-size: 24px;
    border-left: 8px solid $primary-color;
    padding-left: 35px;
  }

  &__action-button {
    margin: 0 auto;
    max-width: 240px;
  }

  @media (max-width: $screen-width-md) {
    &__header-image {
      object-fit: contain;
      height: 242px;
    }

    &__landscape-image {
      height: 328px;
    }

    &__double-image {
      flex-wrap: wrap;

      img {
        margin-bottom: 25px;
        object-fit: cover;
        height: 420px;
        &:first-child {
          margin-right: 0;
        }
      }
    }

    &__social {
      position: initial;
      flex-direction: column;
      text-align: left;
    }
  }
}
</style>
